import React from "react"
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout"
import BoxShadow from "../../../shared/BoxShadow/BoxShadow"
import PageCoursesPriceHeader from "../../../components/AdminPanel/PageCoursesPrice/PageCoursesPriceHeader/PageCoursesPriceHeader"
import PageCoursePriceContent from "../../../components/AdminPanel/PageCoursesPrice/PageCoursesPriceContent/PageCoursePriceContent"


const PageCoursesPricePage = () => {
  return (
    <AdminPanelLayout>
    <BoxShadow>
      <div className="mt-7">
        <PageCoursesPriceHeader />
        <PageCoursePriceContent />
      </div>
    </BoxShadow>
  </AdminPanelLayout>
  )
}

export default PageCoursesPricePage
